import { Domain } from 'types/Domain.type';

export const CPF_PATTERN = /^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/;
export const CPF_RAW_PATTERN = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;

export const CNPJ_PATTERN = /^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})$/;
export const CNPJ_RAW_PATTERN = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;

export const VEHICLE_PLATE_PATTERN = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;

export const isCpf = (value: any): value is Domain.Cpf => {
    if (typeof value !== 'string')
        return false;

    const matches = value.match(CPF_PATTERN) !== null;

    return matches;
};

export const isVehiclePlate = (value: any): value is Domain.Vehicle.Plate => {
    if (typeof value !== 'string')
        return false;

    const matches = value.match(VEHICLE_PLATE_PATTERN) !== null;

    return matches;
};

/** @example '11111111111111' to '11.111.111/1111-11' */
export const makeCnpj = (value: Domain.RawCnpj): Domain.Cnpj => {
    const cnpj = value.replace(CNPJ_RAW_PATTERN, '$1.$2.$3/$4-$5');

    return cnpj as Domain.Cnpj;
};

/** @example '11.111.111/1111-11' to '11111111111111' */
export const makeRawCnpj = (value: Domain.Cnpj): Domain.RawCnpj => {
    /** Matches any character that is not a digit and replace with empty string */
    const cnpj = value.replace(/[^\d]/g, '');

    return cnpj as Domain.RawCnpj;
};

/** @example '11111111111' to '111.111.111-11' */
export const makeCpf = (value: Domain.RawCpf): Domain.Cpf => {
    const cpf = value.replace(CPF_RAW_PATTERN, '$1.$2.$3-$4');

    return cpf as Domain.Cpf;
};

/** @example '111.111.111-11' to '11111111111' */
export const makeRawCpf = (value: Domain.Cpf): Domain.RawCpf => {
    /** Matches any character that is not a digit and replace with empty string */
    const cpf = value.replace(/[^\d]/g, '');

    return cpf as Domain.RawCpf;
};

/** @example 'lsn4b49' to 'LSN4B49' */
export const makeVehiclePlate = (value: Domain.Vehicle.RawPlate): Domain.Vehicle.Plate => {
    const plate = value.toUpperCase();

    return plate as Domain.Vehicle.Plate;
};


/** @example 'LSN4B49' to 'lsn4b49' */
export const makeRawVehiclePlate = (value: Domain.Vehicle.Plate): Domain.Vehicle.RawPlate => {
    const plate = value.toLowerCase();

    return plate as Domain.Vehicle.RawPlate;
};